import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

import elementIcon from "./js/svgicon";
import utils from './js/utils.js'
import request from '@/js/request'
import publicData from './js/public.js'
import { TUIComponents, TUIChatKit } from "@/TUIKit";
import { StoreName, TUIStore } from '@tencentcloud/chat-uikit-engine';
import TUINotification from '@/TUIKit/components/TUINotification';

// 处理element-plus自动导入，部分组件样式失效问题
import 'element-plus/theme-chalk/src/message.scss'
import 'element-plus/theme-chalk/src/message-box.scss'
import 'element-plus/theme-chalk/src/overlay.scss'
import '@wangeditor/editor/dist/css/style.css'

import AudioPlayer from '@liripeng/vue-audio-player'

import './style/index.scss'

import {
    ElMessage,
    ElMessageBox
} from 'element-plus'

router.beforeEach((to, from, next) => {
    if (store.state.token || to.meta.notoken) {
        if (to.path == '/') {
            next({
                name: 'login'
            })
        } else {
            store.dispatch('menu/checkPermission', to).then(check => {
                if (check) {
                    next();
                } else {
                    alert('无权限')
                    next('/login')
                }

            })
        }
    } else {
        next({
            name: 'login',
            query: {
                redirect: to.path
            }
        })
    }
})
const app = createApp(App)
Object.defineProperties(app.config.globalProperties, {
    utils: {
        value: utils,
        writable: false,
    },
    $public: {
        value: publicData,
        writable: false,
    },
    $request: {
        value: request,
        writable: false,
    },
    $message: {
        value: ElMessage,
        writable: false,
    },
    $confirm: {
        value: ElMessageBox.confirm,
        writable: false,
    },
    $msgbox: {
        value: ElMessageBox,
        writable: false,
    },
})
app.component('Editor', Editor).component('Toolbar', Toolbar)
TUIChatKit.components(TUIComponents, app);
app.use(store).use(router).use(elementIcon).component('AudioPlayer', AudioPlayer).mount('#app')

// TUIChatKit init
TUIChatKit.init();
TUIStore.watch(StoreName.CHAT, {
  newMessageList: (newMessageList, ...args)=> {
    console.error('fhw', args)
    if (Array.isArray(newMessageList)) {
      newMessageList.forEach(msg => TUINotification.notify(msg))
    }
  }
})
// app.config.globalProperties.$TUIKit = TUIChatKit